module.exports = "/static/assets/0cef7883deeca23b0f70a19f9868899c.png";